import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PostSPCard from './PostSPCard';
import Tags from "./tags";

const Posts = (params) => {
  const categoria = params.categoria;
  const { tagParam } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;

  const url = useMemo(() => `${baseUrl}/content/posts/${categoria}/${tagParam ? tagParam : ''}`, [baseUrl, categoria, tagParam]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(false);

      
  useEffect(() => {
  const fetchData = () => {
    fetch(url, {
      method: 'GET',
      headers: requestHeaders
      })
      .then((response) => response.json())
      .then((result) => {
        setPages(result.reverse());
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    };
    fetchData();
  }, [url, requestHeaders]);

  if (isLoading) {
    return <CircularProgress className="loading" />;
  }

  return (
    <div>
      <Tags location={categoria === 'Projeto' ? 'projetos' : 'posts'} selecionado={tagParam ? tagParam : 'todos'} />
      <ul className='cards'>
        {pages.map(page => ((categoria === page.categoria) && page.Status === "Publicado" ?
          <li className="cards_item"  key={page.id}>
            <PostSPCard postObject={page} location="lista"/>
          </li>:<p key={page.id}></p>
        ))}
      </ul>
    </div>
  );
};

export default Posts;

